// export const ApiUrl = "https://localhost:44337"; //Local

export const ApiUrl = "https://api.novus.global"; //Calibre Remote

export const GoogleAuth = '/user/googleauth';
export const FacebookAuth = '/user/facebookauth';